import { ProductDetailViewEvent } from '@/usecases/event-bus-for-third-party/event'

export function handleProductDetailViewEvent(event: ProductDetailViewEvent): void {
  /**
   * @see https://github.com/Everforth/growthpalette-front/issues/8263
   */
  window.dataLayer.push({
    pageType: 'productDetail',
    event: 'view_item',
    ecommerce: {
      detail: {
        products: event.fku.map(fku => ({
          item_id: fku.id,
          item_name: event.root.name,
          item_variant: fku.color,
          price: fku.price.min,
        })),
      },
    },
  })
}
